import { environment } from '../../../../../assets/environment/environment';
import { SmartEnum } from '../../../core/primitives/smart-enums/models/smart-enum.model';
import { NotificationMessage } from '../models/notification.message.model';

export const NotificationEnumArray: NotificationEnum[] = [];

export class NotificationEnum extends SmartEnum<NotificationEnum> {
    constructor(name: string) {
        super(name);
    }

    getNotificationRoute(notification: NotificationMessage<any>): string {
        return '';
    }
}
